import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, shallowEqual, useSelector } from 'react-redux';
import { actions as agentFeedbackActions } from 'features/AgentFeedback';

const initialState = {
  link: '',
};

const useAgentFeedback = closeFunction => {
  const dispatch = useDispatch();
  const { link, actionProcessing } = useSelector(state => state.agentFeedback);

  const [state, setState] = useState(initialState);

  const onChangeLink = useCallback(value => {
    setState(prev => ({ ...prev, link: value }));
  }, []);

  useEffect(() => {
    onChangeLink(link);
  }, [link]);

  const handleFormSubmit = e => {
    e.preventDefault();

    dispatch(agentFeedbackActions.updateFeedbackLink(state.link, closeFunction));
  };

  return {
    state,
    handleFormSubmit,
    onChangeLink,
    actionProcessing,
  };
};

export default useAgentFeedback;
